export const loadState = (key: string) => {
  try {
    const serializedState = localStorage.getItem(key);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const saveState = (key: string, object: object) => {
  try {
    const serializedState = JSON.stringify(object);
    localStorage.setItem(key, serializedState);
  } catch {
    // ignore write errors
  }
};
